module.exports = __webpack_public_path__ + "img/lh.8f410033.png";